<form [formGroup]="fieldAdminSeasonsForm">

  <!-- Toolbar -->
  <div class="flex items-center gap-2.5 py-3.5 px-7 flex-wrap">
    <!-- Search -->
    <div class="relative">
      <span class="material-icons absolute left-2.5 top-1/2 -translate-y-1/2 text-[18px] text-[var(--tertiary-text)]">search</span>
      <input type="text" placeholder="Search..." (keyup)="searchPins($event.target.value)"
        class="py-2 pl-9 pr-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] w-[200px] outline-none transition-colors bg-[var(--app-base)] text-[var(--base-text-alt-dark)] focus:border-[var(--primary-dark)] placeholder:text-[var(--base-text-alt-dark)]">
    </div>

    <!-- Status Filter -->
    <div class="relative z-[110]" #statusDropdown>
      <div (click)="showStatusMenu = !showStatusMenu; $event.stopPropagation()"
        class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">filter_list</span>
        <span>{{filterStatus?.description || 'All'}}</span>
        <span class="material-icons text-[16px]">expand_more</span>
      </div>
      <div *ngIf="showStatusMenu"
        class="absolute top-[calc(100%+4px)] left-0 min-w-[160px] bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[100]">
        <div *ngFor="let status of seasonStatuses"
          (click)="setSeasonStatus(status); showStatusMenu = false"
          class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer transition-colors hover:bg-[var(--app-base)]"
          [class.font-semibold]="status.id === filterStatus?.id">
          {{status.description}}
        </div>
      </div>
    </div>

    <!-- Create Season -->
    <button (click)="openCreateNewSeasonDialog()"
      class="py-2 px-3.5 border-none rounded-lg text-xs font-semibold bg-[var(--primary-dark)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
      <span class="material-icons text-[16px]">add</span> CREATE SEASON
    </button>

    <!-- Clear Filters -->
    <button *ngIf="isFilterBtnVisible" (click)="resetFilter()"
      class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      <span class="material-icons text-[16px]">filter_alt_off</span> Clear Filters
    </button>

    <div class="flex-1"></div>

    <!-- Date Range -->
    <div class="flex gap-2.5">
      <ui-datepicker label="Between Start" [value]="startDateDisplay" (valueChange)="onStartDatePicked($event)"></ui-datepicker>
      <ui-datepicker label="Between End" [value]="endDateDisplay" (valueChange)="onEndDatePicked($event)"></ui-datepicker>
    </div>
  </div>

</form>

<!-- Table -->
<div class="px-7 overflow-y-auto" style="height: calc(100vh - 260px);">
  <table mat-table [dataSource]="dataSource" class="w-full border-collapse">

    <ng-container matColumnDef="seasonName">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Season Name</th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.seasonName ?? placeholder}}</td>
    </ng-container>

    <ng-container matColumnDef="dateCreated">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Date Created</th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-normal !text-[var(--tertiary-text)] !border-b !border-[var(--app-base)]">{{element?.dateCreated ? dayjs(element.dateCreated).format(dateStringFormatting) : placeholder}}</td>
    </ng-container>

    <ng-container matColumnDef="startDate">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Start Date</th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-normal !text-[var(--tertiary-text)] !border-b !border-[var(--app-base)]">{{element?.startDate ? dayjs(element.startDate).format(dateStringFormatting) : placeholder}}</td>
    </ng-container>

    <ng-container matColumnDef="endDate">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">End Date</th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-normal !text-[var(--tertiary-text)] !border-b !border-[var(--app-base)]">{{element?.endDate ? dayjs(element.endDate).format(dateStringFormatting) : placeholder}}</td>
    </ng-container>

    <ng-container matColumnDef="totalFieldsCamps">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Total Fields/Camps</th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.totalFields ?? placeholder}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Status</th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-semibold !border-b !border-[var(--app-base)]"
        [ngClass]="{
          '!text-[var(--notification-success)]': element.status === 'Started',
          '!text-[var(--notification-error)]': element.status === 'Ended',
          '!text-[var(--tertiary-text)]': element.status === 'Not Started'
        }">
        {{element?.status ?? placeholder}}
      </td>
    </ng-container>

    <ng-container matColumnDef=" ">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !bg-[var(--app-base)] !border-b !border-[var(--app-base)]"></th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !border-b !border-[var(--app-base)]">
        <div class="flex items-center justify-between w-full">
          <button (click)="openEndSeasonDialog(element.id); $event.stopPropagation()"
            class="py-1.5 px-3 rounded-lg text-[11px] font-semibold border-none cursor-pointer bg-[var(--notification-success)] text-white hover:opacity-90 transition-all">
            END
          </button>
          <div class="pl-6 pr-4 flex items-center justify-center">
            <span class="material-icons text-[18px] text-[var(--tertiary-text)] cursor-pointer hover:text-[var(--primary-dark)]" (click)="viewSeason(element.id)">chevron_right</span>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: auto; min-height: unset"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      class="transition-colors !h-auto cursor-pointer"
      style="height: auto; min-height: unset"
      (click)="viewSeason(row.id)"></tr>
  </table>

  <div *ngIf="isNoItemsFound" class="flex items-center justify-center text-[var(--tertiary-text)] text-[13px] py-20">
    Sorry! No items found within the selected filter range.
  </div>
</div>

<!-- Paginator -->
<div class="flex items-center justify-end py-3.5 px-7 gap-4 border-t border-[var(--app-base)]">
  <span class="text-[12px] text-[var(--tertiary-text)] font-medium">Items per page:</span>
  <div class="relative" #pageSizeDropdown>
    <div (click)="showPageSizeMenu = !showPageSizeMenu; $event.stopPropagation()"
      class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      <span>{{pageSize}}</span>
      <span class="material-icons text-[16px]">expand_more</span>
    </div>
    <div *ngIf="showPageSizeMenu"
      class="absolute bottom-[calc(100%+4px)] left-0 min-w-[80px] bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[100]">
      <div *ngFor="let size of [5, 10, 25]"
        (click)="onPageSizeChange(size)"
        class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer transition-colors hover:bg-[var(--app-base)]"
        [class.font-semibold]="size === pageSize">
        {{size}}
      </div>
    </div>
  </div>
  <span class="text-[13px] text-[var(--base-text-alt-dark)] font-medium">{{currentPage * pageSize + 1}} – {{min((currentPage + 1) * pageSize, totalElements)}} of {{totalElements}}</span>
  <div class="flex gap-1">
    <button (click)="goToPage(0)" [disabled]="currentPage === 0"
      class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
      <span class="material-icons text-[16px]">first_page</span>
    </button>
    <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 0"
      class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
      <span class="material-icons text-[16px]">chevron_left</span>
    </button>
    <button (click)="goToPage(currentPage + 1)" [disabled]="(currentPage + 1) * pageSize >= totalElements"
      class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
      <span class="material-icons text-[16px]">chevron_right</span>
    </button>
    <button (click)="goToPage(lastPage)" [disabled]="(currentPage + 1) * pageSize >= totalElements"
      class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
      <span class="material-icons text-[16px]">last_page</span>
    </button>
  </div>
</div>
